module.exports = __webpack_public_path__ + "img/success.21445580.svg";